import LeadDetails from '../leadDetails';

const LivePromotionDetails = ({isOpen, onClose, showClass}) => {
    
    if(!isOpen) return null;
    
    return (
        <LeadDetails 
            isOpen={isOpen} 
            onClose={onClose} 
            leadName="livePromotion"
            showClass={showClass}
        />
    );
};

export default LivePromotionDetails;
